import { useEffect, useState } from 'react'
import { popAlertQueue } from '../../../cache/alerts'
import { MessageType } from '../../../ts/enums/messageType.enums'
import { AlertProps } from '../../../ts/interfaces/alertProps.interface'
import Correction from './Correction'
import ErrorAlert from './Error'
import Info from './Info'
import Success from './Success'
import Warning from './Warning'

const Alert = ({
  type,
  id,
  pauseAutoHide,
  pauseAutoHideProp = false,
  message,
  autoHideTimeout,
  onClose,
  onOk,
  okButtonLabel,
}: AlertProps) => {
  const shouldAutoHide = type === MessageType.SUCCESS && !pauseAutoHideProp
  const [isPaused, setIsPaused] = useState(pauseAutoHide)

  useEffect(() => {
    setIsPaused(pauseAutoHide)
  }, [pauseAutoHide])

  useEffect(() => {
    if (!shouldAutoHide) {
      return
    }

    const interval = setInterval(() => {
      if (!isPaused) {
        popAlertQueue(id)
      }
    }, autoHideTimeout)

    return () => clearInterval(interval)
  }, [isPaused, shouldAutoHide, id, autoHideTimeout])

  useEffect(() => {
    if (!shouldAutoHide) {
      return
    }

    const interval = setInterval(() => {
      if (!isPaused) {
        popAlertQueue(id)
      }
    }, autoHideTimeout)

    return () => clearInterval(interval)
  }, [isPaused, shouldAutoHide, id, autoHideTimeout])

  const handleOnClose = () => {
    popAlertQueue(id)
    onClose?.()
  }
  const handleOnOK = () => {
    popAlertQueue(id)
    onOk?.()
  }

  const renderAlertType = (type: MessageType) => {
    switch (type) {
      case MessageType.SUCCESS:
        return (
          <Success
            description={message}
            okButtonLabel={okButtonLabel}
            {...(onOk && { onOk: handleOnOK })}
            onClose={handleOnClose}
          />
        )
      case MessageType.WARNING:
        return (
          <Warning
            description={message}
            okButtonLabel={okButtonLabel}
            {...(onOk && { onOk: handleOnOK })}
            onClose={handleOnClose}
          />
        )
      case MessageType.INFO:
        return (
          <Info
            description={message}
            okButtonLabel={okButtonLabel}
            {...(onOk && { onOk: handleOnOK })}
            onClose={handleOnClose}
          />
        )
      case MessageType.ERROR:
        return <ErrorAlert description={message} onClose={handleOnClose} />
      case MessageType.CORRECTION:
        return <Correction onClose={handleOnClose} />
    }
  }

  return <>{renderAlertType(type)}</>
}

export default Alert
